import generateBlobHelper from "./generateBlobHelper";

function downloadFileHelper(result) {
    let blob = generateBlobHelper(result);

    const data = window.URL.createObjectURL(blob);

    const link = document.createElement('a');

    link.href = data;
    link.download = result.data.fileName;
    link.click();
}

export default downloadFileHelper;